import { Flex } from 'dash-ui';
import styled from 'styled-components';

export const TopRowWidgetsWraper = styled(Flex)`
  @media ${({ theme }) => theme.devices.mobile} {
    margin-bottom: 0px;
    flex-direction: column;
    & > div {
      margin-right: 0px;
      margin-left: 0px;
      margin-bottom: 12px;
    }
  }
`;
